module.exports = __webpack_public_path__ + "img/embargo.a4295646.svg";